export function initJCFSelect() {
	
	jcf.setOptions({
		wrapNative: false,
		fakeDropInBody: false,
		maxVisibleItems: 6,
		useCustomScroll: true
	});
	
	jcf.replaceAll();
}


// WEBPACK FOOTER //
// ./assets/js/modules/jcf-init.js